import React from 'react'
import { GrowthWheelAssessmentSession } from '../../types/GrowthWheel'

interface Props {
  comparisonSessions: GrowthWheelAssessmentSession[]
  selectedScoreField: 'selfLevel' | 'leaderLevel'
  selectedSessionIds: number[]
  onPrimarySessionChange: (sessionId: number) => void
  onScoreFieldChange: (scoreField: 'selfLevel' | 'leaderLevel') => void
  onSecondarySessionChange: (sessionId: string) => void
}

export function GrowthComparisonChartControls({
  comparisonSessions,
  selectedScoreField,
  selectedSessionIds,
  onPrimarySessionChange,
  onScoreFieldChange,
  onSecondarySessionChange,
}: Props) {
  return (
    <div className="gw-growth-comparison-controls">
      <select
        value={selectedScoreField}
        onChange={event =>
          onScoreFieldChange(event.target.value as 'selfLevel' | 'leaderLevel')
        }
        className="gw-growth-comparison-select"
      >
        <option value="selfLevel">Self scores</option>
        <option value="leaderLevel">Reviewer scores</option>
      </select>
      <select
        value={selectedSessionIds[0] ?? ''}
        onChange={event => onPrimarySessionChange(Number(event.target.value))}
        className="gw-growth-comparison-select"
      >
        {comparisonSessions.map(session => (
          <option key={session.id} value={session.id}>
            {session.name}
          </option>
        ))}
      </select>
      <select
        value={selectedSessionIds[1] ?? ''}
        onChange={event => onSecondarySessionChange(event.target.value)}
        className="gw-growth-comparison-select"
      >
        <option value="">Compare with...</option>
        {comparisonSessions
          .filter(session => session.id !== selectedSessionIds[0])
          .map(session => (
            <option key={session.id} value={session.id}>
              {session.name}
            </option>
          ))}
      </select>
    </div>
  )
}
